// Referenzen für die Seite /referenzen. Neueste zuerst.
// Neues Projekt: Eintrag oben ergänzen. Pflicht: id, titel, leistung, text (ein Absatz als Text oder mehrere als Liste).
// Optional: ort (z. B. "Schönberg"; muss dann in orte.js stehen), jahr,
//   vergleich: { vorher, nachher, vorherAlt, nachherAlt, ratio, breite, hoehe } – Bildpaar vom gleichen Standpunkt, gleiches Format,
//   bilder: Liste von { src, alt, label, breite, hoehe } – Fotos, die nebeneinander gezeigt werden.
//   breite/hoehe = Pixelmaße der Bilddatei (damit der Browser vor dem Laden den Platz reserviert).
//   ratio = [Breite, Höhe] des Vergleichsbildes für das CSS (z. B. [16, 9] oder [9, 16]); label = Beschriftung am Foto (z. B. "Vorher").
// Ohne Bilder erscheint der Eintrag als reine Textkarte. Ohne ort bekommt er auf der Karte eine gestrichelte Nadel an
// beispielhafter Position (mit Hinweis unter der Karte) und erscheint wie alle anderen in der Liste.
// Bilder in src/components/pages/images/Referenzen/ ablegen und hier importieren. Vorher verkleinern und als WebP speichern
// (Qualität ca. 80 %): Fotos der Bildreihe (bilder) 540×960 (hoch) bzw. 1000 px lange Kante (quer), die Galerie zeigt sie nur 384 px hoch;
// Vorher/Nachher-Paare (vergleich) 675×1200 (hoch) bzw. 1600 px (quer).
// Die Umwandlung geht ohne npm-Pakete (npm install ist auf dem Entwicklungsrechner defekt), z. B. mit einem kleinen Node-Skript,
// das Chrome headless (Canvas, toBlob "image/webp") nutzt. Die älteren MulcherVorher/-Nachher-Bilder sind noch JPEG.
import MulcherVorher from "../components/pages/images/VorherNacher/MulcherVorher.webp";
import MulcherNachher from "../components/pages/images/VorherNacher/MulcherNachher.webp";
import PfeifengrasVorher from "../components/pages/images/Referenzen/pfeifengraswiese-vorher.webp";
import PfeifengrasNachher from "../components/pages/images/Referenzen/pfeifengraswiese-nachher.webp";
import ObstwieseVorher from "../components/pages/images/Referenzen/obstwiese-vorher.webp";
import ObstwieseNachher from "../components/pages/images/Referenzen/obstwiese-nachher.webp";
import Deponie1 from "../components/pages/images/Referenzen/deponie-1.webp";
import Deponie2 from "../components/pages/images/Referenzen/deponie-2.webp";
import Deponie3 from "../components/pages/images/Referenzen/deponie-3.webp";
import Holz1 from "../components/pages/images/Referenzen/holzeinschlag-1.webp";
import Holz2 from "../components/pages/images/Referenzen/holzeinschlag-2.webp";
import WegrandVorher from "../components/pages/images/Referenzen/wegrand-vorher.webp";
import WegrandNachher from "../components/pages/images/Referenzen/wegrand-nachher.webp";
import Deich1 from "../components/pages/images/Referenzen/deich-1.webp";
import Deich2 from "../components/pages/images/Referenzen/deich-2.webp";
import Deich3 from "../components/pages/images/Referenzen/deich-3.webp";
import Friedhof1 from "../components/pages/images/Referenzen/friedhof-1.webp";
import Friedhof2 from "../components/pages/images/Referenzen/friedhof-2.webp";
import Hohwacht1 from "../components/pages/images/Referenzen/hohwacht-1.webp";
import Hohwacht2 from "../components/pages/images/Referenzen/hohwacht-2.webp";
import Hohwacht3 from "../components/pages/images/Referenzen/hohwacht-3.webp";

const referenzen = [
  {
    id: "deichpflege-stoer",
    titel: "Deichpflege an der Stör",
    leistung: "Baumfällung",
    ort: "Itzehoe",
    jahr: "2026",
    text: [
      "Im Rahmen der Deichpflege an der Stör wurden auf dem Deich gewachsene Bäume entfernt. Ziel der Maßnahme war es, die Widerstandsfähigkeit des Deichkörpers zu erhalten und den unerwünschten Gehölzbewuchs zurückzunehmen.",
      "Zum Schutz des Deiches war der Einsatz leichter Technik gefragt. Mit der kompakten Forstraupe konnten die Arbeiten auch auf den geneigten Flächen bodenschonend durchgeführt werden. Ihr geringes Eigengewicht und der niedrige Bodendruck boten gute Voraussetzungen, um die empfindliche Deichoberfläche zu schonen.",
    ],
    bilder: [
      { src: Deich1, breite: 540, hoehe: 960, alt: "Forstraupe Moritz FR 75 auf dem Deichweg an der Stör zieht mit der Seilwinde einen gefällten Stamm heran" },
      { src: Deich2, breite: 540, hoehe: 960, alt: "Forstraupe von hinten auf der Deichkrone, davor das gefällte Gehölz, Schilf und Nebel über der Stör" },
      { src: Deich3, breite: 540, hoehe: 960, alt: "Forstraupe Moritz FR 75 mit angehängtem Holzhacker auf dem verschneiten Deich" },
    ],
  },
  {
    id: "verkehrssicherung-friedhof-probsteierhagen",
    titel: "Verkehrssicherung auf dem Friedhof",
    leistung: "Baumpflege",
    ort: "Probsteierhagen",
    jahr: "2026",
    text: [
      "Im Rahmen der Verkehrssicherung wurde auf einem Friedhof Totholz aus den Baumkronen entfernt und entlang der Wege wurden Lichtraumprofilschnitte durchgeführt. Abgestorbene Äste wurden gezielt entnommen und in die Verkehrswege hineinragende Äste zurückgeschnitten, um die sichere Nutzung und freie Durchgängigkeit der Wege zu unterstützen.",
      "Besonderes Augenmerk lag auf dem Schutz der Grabstätten, der angrenzenden Bepflanzung und der Wegeflächen. Die Arbeiten wurden unter Berücksichtigung des vorhandenen Baumbestands und des besonderen Charakters des Friedhofs ausgeführt.",
    ],
    bilder: [
      { src: Friedhof1, breite: 540, hoehe: 960, alt: "Hubarbeitsbühne mit ausgefahrenen Stützen, Baumpfleger im Korb in der Krone eines alten, kahlen Laubbaums, verschneite Umgebung" },
      { src: Friedhof2, breite: 540, hoehe: 960, alt: "Hubarbeitsbühne neben einer verschneiten Baumreihe, am Straßenrand Leitkegel, Holzhäcksler und Kipper" },
    ],
  },
  {
    id: "holzeinschlag-schrevenborn",
    titel: "Holzeinschlag und Rückearbeiten",
    leistung: "Baumfällung",
    ort: "Schrevenborn",
    jahr: "Winter 2025/26",
    text: [
      "Im Winter 2025/2026 wurden für die Gutsverwaltung Schrevenborn Bäume gefällt und die Stammabschnitte anschließend mit der Forstraupe Pfanzelt Moritz FR 75 gerückt. Die integrierte Seilwinde unterstützte die gezielte Fällung und ermöglichte die Bergung des Holzes aus schwer zugänglichen Bereichen.",
      "Die kompakte Bauweise und hohe Wendigkeit erleichterten den Einsatz zwischen den verbleibenden Bäumen. Mit einem spezifischen Bodendruck von nur rund 0,28 kg/cm² bietet die Raupe gute Voraussetzungen für bodenschonendes Arbeiten.",
    ],
    bilder: [
      { src: Holz1, breite: 540, hoehe: 960, alt: "Gefällter Stammabschnitt im Vordergrund, dahinter die Forstraupe Moritz FR 75 mit Seilwinde im Laubwald" },
      { src: Holz2, breite: 540, hoehe: 960, alt: "Forstraupe Moritz FR 75 steht schräg an drei aufgeschichteten Stämmen auf einem Waldweg im Laubwald" },
    ],
  },
  {
    id: "pfeifengraswiese",
    titel: "Pflegemaßnahmen auf einer Pfeifengraswiese",
    leistung: "Landschaftspflege",
    ort: "Seth",
    jahr: "2026",
    text: [
      "Auf dieser schützenswerten Pfeifengraswiese wurde unerwünschter Gehölzaufwuchs entfernt, um die offene Struktur der Fläche zu erhalten. Ohne entsprechende Pflege würden sich Sträucher und junge Bäume zunehmend ausbreiten und die charakteristische Wiesenvegetation verdrängen.",
      "Durch die gezielte Gehölzentfernung wurde wieder mehr Licht und Raum für die typischen Pflanzen der Pfeifengraswiese geschaffen. Die Maßnahme trägt dazu bei, den besonderen Charakter der Fläche zu bewahren und den wertvollen Lebensraum für spezialisierte Tier- und Pflanzenarten langfristig zu erhalten.",
    ],
    vergleich: {
      vorher: PfeifengrasVorher,
      nachher: PfeifengrasNachher,
      vorherAlt: "Vorher: Pfeifengraswiese im Winter mit dichtem Strauch- und Gehölzaufwuchs",
      nachherAlt: "Nachher: freigestellte, offene Wiesenfläche mit einzelnen erhaltenen Birken",
      ratio: [16, 9],
      breite: 1600,
      hoehe: 900,
    },
  },
  {
    id: "deponie",
    titel: "Pflege eines Deponiekörpers",
    leistung: "Landschaftspflege",
    jahr: "2026",
    // Ort auf Wunsch des Auftraggebers nicht genannt
    text: [
      "Im Rahmen der Pflege eines Deponiekörpers wurde der Bewuchs mit der funkgesteuerten Mulchraupe zurückgeschnitten. Als technisches Bauwerk stellt ein Deponiekörper besondere Anforderungen an die Flächenpflege. Neben dem Schutz der sensiblen Deckschicht mussten dabei die steilen Böschungen berücksichtigt werden.",
      "Die geländegängige Raupe ermöglichte eine bodenschonende Bearbeitung der geneigten Flächen. Durch die Funksteuerung konnte die Maschine von einem geeigneten Standort aus bedient werden. Die gepflegte Oberfläche sorgt für ein übersichtliches Erscheinungsbild und erleichtert die regelmäßige Sichtkontrolle des Bauwerks.",
    ],
    bilder: [
      { src: Deponie1, breite: 540, hoehe: 960, alt: "Funkgesteuerte Mulchraupe mäht hohes Gras auf der Kuppe des Deponiekörpers" },
      { src: Deponie2, breite: 540, hoehe: 960, alt: "Mulchraupe an der steilen Böschung, im Hintergrund das Deponiegelände" },
      { src: Deponie3, breite: 540, hoehe: 960, alt: "Mulchraupe quer am Steilhang, die Böschung darunter ist bereits gemulcht" },
    ],
  },
  {
    id: "verkehrssicherung-hohwacht",
    titel: "Verkehrssicherung an einer Landesstraße",
    leistung: "Baumpflege",
    ort: "Hohwacht",
    jahr: "2025",
    text: [
      "An einer viel befahrenen Landesstraße wurde Totholz aus den straßenbegleitenden Bäumen entfernt. Abgestorbene Äste wurden gezielt entnommen, um die Gefahr durch herabfallendes Astmaterial zu verringern und die Verkehrssicherheit zu unterstützen.",
      "Die Arbeiten erforderten aufgrund des hohen Verkehrsaufkommens eine sorgfältige Planung und Absicherung des Arbeitsbereichs. Besonderes Augenmerk lag auf dem Schutz der Verkehrsteilnehmer und einer kontrollierten Durchführung unter Berücksichtigung des fließenden Verkehrs.",
    ],
    bilder: [
      { src: Hohwacht1, breite: 1000, hoehe: 753, alt: "Mit Leitkegeln abgesicherte Küstenstraße: links der Unimog mit Seilwinde, rechts die Hubarbeitsbühne mit Baumpfleger in den Alleebäumen" },
      { src: Hohwacht2, breite: 720, hoehe: 956, alt: "Hubarbeitsbühne ragt schräg in die Kronen der Alleebäume vor tiefblauem Himmel" },
      { src: Hohwacht3, breite: 720, hoehe: 956, alt: "Unimog mit Seilwinde am Straßenrand unter efeubewachsenen Alleebäumen, Leitkegel und Motorsäge am Wegrand" },
    ],
  },
  {
    id: "obstwiese",
    titel: "Pflege einer Obstwiese",
    leistung: "Landschaftspflege",
    text: "Auf dieser Obstwiese wurden die Obstbäume leicht beschnitten und die Fläche mit unserer funkgesteuerten Raupe gemulcht. Durch die Pflege kommt der Charakter der Wiese wieder zur Geltung: Die Fläche wirkt offener, gepflegter und einladender.",
    bilder: [
      { src: ObstwieseVorher, breite: 1600, hoehe: 900, label: "Vorher", alt: "Vorher: Obstwiese mit hohem, verfilztem Gras unter den Bäumen" },
      { src: ObstwieseNachher, breite: 540, hoehe: 960, label: "Nachher", alt: "Nachher: gemulchte, offene Fläche zwischen den beschnittenen Obstbäumen" },
    ],
  },
  {
    id: "gehoelzrand-freistellen",
    titel: "Zugewachsener Gehölzrand freigestellt",
    leistung: "Landschaftspflege",
    text: "Dichter Aufwuchs aus Gehölzen, Brombeeren und hohem Gras wurde mit dem funkgesteuerten Geräteträger gemulcht. Die Altbäume blieben stehen, das zerkleinerte Material verblieb als Mulchschicht auf der Fläche.",
    vergleich: {
      vorher: MulcherVorher,
      nachher: MulcherNachher,
      vorherAlt: "Vorher: dichter Aufwuchs aus Gehölzen, Brombeeren und hohem Gras am Waldrand",
      nachherAlt: "Nachher: gemulchte, freigestellte Fläche vor den erhaltenen Altbäumen",
      breite: 675,
      hoehe: 1197,
    },
  },
  {
    id: "wegrand-freistellen",
    titel: "Zugewachsener Wegrand gemulcht",
    leistung: "Landschaftspflege",
    text: "Brennnesseln, Disteln und Brombeeren hatten die Fläche am Wegrand überwuchert. Mit der funkgesteuerten Raupe wurde der Aufwuchs gemulcht, die Esche und die Büsche blieben stehen.",
    vergleich: {
      vorher: WegrandVorher,
      nachher: WegrandNachher,
      vorherAlt: "Vorher: Fläche am Wegrand dicht mit Brennnesseln, Disteln und Brombeeren zugewachsen, in der Mitte eine Esche",
      nachherAlt: "Nachher: dieselbe Stelle gemulcht, Esche und Büsche freigestellt, im Abendlicht",
      breite: 675,
      hoehe: 1200,
    },
  },
];

export default referenzen;
